export * from 'server/models/BillCoverage';


// WEBPACK FOOTER //
// ./data/models/BillCoverage.ts